import { Link } from 'react-router-dom';

const footerLinks = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'About', path: '/about' },
  { label: 'Location', path: '/location' },
];

export default function Footer() {
  return (
    <footer className="bg-parchment border-t border-stone">
      <div className="max-w-7xl mx-auto px-8 lg:px-16 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          {/* Brand — wide column */}
          <div className="lg:col-span-5">
            <Link to="/" className="inline-block mb-6 cursor-pointer" aria-label="Talo Architect">
              <img
                src="https://storage.readdy-site.link/project_files/dee54ef1-5999-4bcb-b321-ea9937ee8043/1be9aad7-eb01-4664-a9b0-4bd3de2c6806_talo-logo.png?v=a7ee781370f881c08b811bb6b39ede89"
                alt="Talo Architect, P.C."
                className="h-10 w-auto object-contain brightness-0"
              />
            </Link>
            <p className="font-sans text-sm text-warm-gray leading-[1.85] max-w-sm mb-6">
              A residential architecture studio in Scarsdale, NY — dedicated to designing homes with intention, where simplicity, function, and timeless form converge.
            </p>
            <div className="flex gap-3">
              {['google', 'facebook', 'home-4'].map((icon, i) => (
                <a
                  key={i}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center border border-stone text-warm-gray hover:border-dark-ink hover:text-dark-ink transition-colors cursor-pointer"
                >
                  <i className={`ri-${icon}-line text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Nav */}
          <div className="lg:col-span-2">
            <h4 className="font-sans text-[10px] tracking-[0.2em] uppercase text-dark-ink mb-6">Navigation</h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="font-sans text-sm text-warm-gray hover:text-dark-ink transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="lg:col-span-2">
            <h4 className="font-sans text-[10px] tracking-[0.2em] uppercase text-dark-ink mb-6">Services</h4>
            <ul className="space-y-3">
              {['Custom Home Design', 'Renovations & Additions', 'New Home Design', 'Interior Planning'].map((s) => (
                <li key={s}>
                  <Link to="/services" className="font-sans text-sm text-warm-gray hover:text-dark-ink transition-colors cursor-pointer">
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-3">
            <h4 className="font-sans text-[10px] tracking-[0.2em] uppercase text-dark-ink mb-6">Contact</h4>
            <ul className="space-y-3 mb-6">
              <li>
                <a href="tel:+19146452940" className="font-sans text-sm text-warm-gray hover:text-dark-ink transition-colors cursor-pointer">
                  (914) 645-2940
                </a>
              </li>
              <li>
                <a href="mailto:talo.tapan@gmail.com" className="font-sans text-sm text-warm-gray hover:text-dark-ink transition-colors cursor-pointer">
                  talo.tapan@gmail.com
                </a>
              </li>
              <li>
                <Link to="/location" className="font-sans text-sm text-warm-gray hover:text-dark-ink transition-colors cursor-pointer">
                  Scarsdale, NY 10583
                </Link>
              </li>
              <li className="font-sans text-sm text-warm-gray">
                Serving NYC &amp; Westchester
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-stone mt-16 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-sans text-xs text-warm-gray">
            &copy; {new Date().getFullYear()} Talo Architect, P.C. All rights reserved. Residential Architecture · Scarsdale, NY
          </p>
          <div className="flex gap-6">
            <a href="#" rel="nofollow" className="font-sans text-xs text-warm-gray hover:text-dark-ink transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" rel="nofollow" className="font-sans text-xs text-warm-gray hover:text-dark-ink transition-colors cursor-pointer">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
